
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1 4.556h16m-11.556 0V2.778A1.778 1.778 0 017.223 1h3.556a1.778 1.778 0 011.778 1.778v1.778m2.666 0V17a1.778 1.778 0 01-1.777 1.778h-8.89A1.778 1.778 0 012.779 17V4.556h12.444zM7.222 9v5.333M10.778 9v5.333","stroke":"#000","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    